import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

const { colors } = tokens;

export const tooltip = (isDesktop = true) => css`
  max-width: 260px;
  display: inline-block;
  z-index: 1;

  ${!isDesktop &&
  css`
    max-width: 112px;
  `}
`;

export const infoIcon = css`
  z-index: 1;
  color: ${colors.neutral.medium.default};

  &:hover,
  &:active {
    cursor: pointer;
    color: ${colors.neutral.medium.hover};
  }
`;
